import { render, staticRenderFns } from "./CategoryUpdateDialogDescription.vue?vue&type=template&id=7f3c65c2&scoped=true"
import script from "./CategoryUpdateDialogDescription.vue?vue&type=script&lang=ts"
export * from "./CategoryUpdateDialogDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3c65c2",
  null
  
)

export default component.exports